"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1045],{

/***/ 11045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_HeaderContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/containers/data/menu.json
var menu_namespaceObject = JSON.parse('[{"name":"Auto <br class=\\"hide-w-lg\\"> in vendita","title":"Auto in vendita","href":"/offerte-auto","target":"_self","children":[]},{"name":"Auto Noleggio <br class=\\"hide-w-lg\\"> Lungo Termine","title":"Auto Noleggio Lungo Termine","href":"/noleggio-a-lungo-termine","target":"_self","children":[{"name":"Noleggio per privati","title":"Noleggio a Lungo Termine per privati","href":"/noleggio-a-lungo-termine/offerte-privati","target":"_self"},{"name":"Noleggio per aziende","title":"Noleggio a Lungo Termine per aziende","href":"/noleggio-a-lungo-termine/offerte-aziende","target":"_self"},{"name":"Noleggio senza anticipo","title":"Noleggio a Lungo Termine senza anticipo","href":"/noleggio-a-lungo-termine/senza-anticipo","target":"_self"},{"name":"Noleggio low cost","title":"Noleggio a Lungo Termine low cost","href":"/noleggio-a-lungo-termine/low-cost","target":"_self"},{"name":"Noleggio consegna veloce","title":"Noleggio a Lungo Termine consegna veloce","href":"/noleggio-a-lungo-termine/offerte-consegna-veloce","target":"_self"}]},{"name":"Auto <br class=\\"hide-w-lg\\"> elettriche","title":"Noleggio a Lungo Termine auto elettriche","href":"/offerte-auto?alimentazione=elettrica,ibrida","target":"_self","children":[{"name":"Auto Elettriche Acquisto","title":"Acquisto auto elettriche","href":"/offerte-auto?alimentazione=elettrica,ibrida","target":"_self"},{"name":"Auto Elettriche Noleggio","title":"Noleggio a Lungo Termine auto elettriche","href":"/auto-elettriche/noleggio-a-lungo-termine","target":"_self"}]},{"name":"I nostri <br class=\\"hide-w-lg\\"> Marchi","title":"I nostri Marchi di NLT","href":"/noleggio-lungo-termine-marchi","target":"_self","children":[]},{"name":"Vantaggi <br class=\\"hide-w-lg\\"> del noleggio","title":"Vantaggi del Noleggio a Lungo Termine","href":"/noleggio-a-lungo-termine/vantaggi","target":"_self","children":[]},{"name":"Blog","title":"Visita il Blog di CarPlanner","href":"https://blog.carplanner.com","target":"_blank","children":[]}]');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/HeaderContainer.tsx




const HeaderComponent = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(8604)]).then(__webpack_require__.bind(__webpack_require__, 48604)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48604)]
  }
});
const href = '/';

const HeaderContainer = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderComponent, {
    title: title,
    href: href,
    menuItems: menu_namespaceObject
  });
};

/* harmony default export */ var containers_HeaderContainer = (HeaderContainer);

/***/ })

}]);